<svelte:options customElement={{
  tag: 'image-column',
  shadow: 'none',
  props: {
    items: { reflect: true, type: 'String' },
    columns: { reflect: true, type: 'Number' },
    spColumns: { reflect: true, type: 'Number', attribute: 'sp-columns' },
    withCaption: { reflect: true, type: 'Boolean', attribute: 'with-caption' }
  }
}} />

<script>
  /**
   * image1/2：画像カラム配置（キャプション有無）
   * パーツライブラリ準拠の mod-column / __caption 構造
   * @prop {string} items - JSON '[{"src":"...","alt":"...","caption":"..."}]'
   * @prop {number} columns - PCカラム数 (1〜5)
   * @prop {number} spColumns - SPカラム数 (1〜5)
   * @prop {boolean} withCaption - キャプション付き
   */
  export let items = '[]';
  export let columns = 3;
  export let spColumns = 1;
  export let withCaption = false;

  let parsedItems = [];

  $: {
    try {
      parsedItems = typeof items === 'string' ? JSON.parse(items) : (Array.isArray(items) ? items : []);
    } catch (e) {
      console.warn('ImageColumn: Invalid items JSON', e);
      parsedItems = [];
    }
  }

  $: wrapClass = withCaption ? 'mod-column __caption' : 'mod-column';
  $: colClass = `__column_${columns}`;
  $: spColClass = `__column_sp_${spColumns}`;
</script>

<div class={wrapClass}>
  {#each parsedItems as item}
    <div class="{colClass} {spColClass}">
      {#if withCaption}
        <figure>
          {#if item.href}
            <a href={item.href}>
              <img src={item.src} alt={item.alt || ''} />
            </a>
          {:else}
            <img src={item.src} alt={item.alt || ''} />
          {/if}
          {#if item.caption}
            <figcaption>
              {#if item.href}
                <a href={item.href}>{item.caption}</a>
              {:else}
                {item.caption}
              {/if}
            </figcaption>
          {/if}
        </figure>
      {:else}
        {#if item.href}
          <a href={item.href}>
            <img src={item.src} alt={item.alt || ''} />
          </a>
        {:else}
          <img src={item.src} alt={item.alt || ''} />
        {/if}
      {/if}
    </div>
  {/each}
  <slot></slot>
</div>
